export const RESERVATION = "03dba2f6-8217-42f9-83f0-08944fd92041"

export const ADVANCED = "0f49f9dc-2026-44fa-ac91-f4ac65b1752d"

export const ADVANCED_RATE = 0.9